
import { IItemDetailsRowProps } from '../components/itemSetDetailsList/ItemDetailsRow';
import { IGroupItemDetailsHeaderProps } from '../components/itemSetDetailsList/GroupItemDetailsHeader';
import { IDetailsListProps, IGroupRenderProps } from 'office-ui-fabric-react/lib/DetailsList';
import { IListProps } from 'office-ui-fabric-react/lib/List';
import { ControlFacet } from '../models/controls/ControlFacet';
import { defaultRenderComponentOption } from '../components/controls/defaultRenderComponentControlOption';
import { IComponentAsProps } from '@uifabric/utilities/lib/IComponentAs';
import { graftControlOption } from '../models/controls/graftControlOption';

/**
 * @beta
 */
export interface IItemSetDetailsListControlProps {
    /**
     * The item set being rendered in the Details List.
     */
    itemSetKey: string | undefined;
}

/**
 * @beta
 */
export type IItemSetDetailsListControlOverrides = Partial<Pick<IDetailsListProps,
    'className' |
    'isHeaderVisible' |
    'constrainMode' |
    'initialFocusedIndex' |
    'onRenderDetailsFooter' |
    'onShouldVirtualize'
    >> & {
    groupProps: Pick<IGroupRenderProps, 'collapseAllVisibility' | 'onRenderFooter'>;
    /**
     * An optional override for the row renderer.
     * To intercept props intended for the default renderer, provide a React component
     * which accepts IComponentAsProps
     */
    rowRenderer: React.ComponentType<IComponentAsProps<IItemDetailsRowProps>>;
    /**
     * An optional override for the group header renderer.
     */
    groupHeaderRenderer: React.ComponentType<IComponentAsProps<IGroupItemDetailsHeaderProps>>;

    /**
     * An optional override for whether render ahead or behind windows in addition to the visible window.
     * Default to 0 to optimize memory usuage.
     */
    listProps: Pick<IListProps, 'renderedWindowsAhead' | 'renderedWindowsBehind' | 'onRenderPage' | 'getItemCountForPage'>
};

/**
 * Control hook for overriding how a Details List is rendered for a particular item set.
 * @beta
 */
export const itemSetDetailsListControl = new ControlFacet<
    IItemSetDetailsListControlProps,
    IItemSetDetailsListControlOverrides
    >('itemDetailsListControl', {
        rowRenderer: defaultRenderComponentOption<IItemDetailsRowProps>(),
        groupHeaderRenderer: defaultRenderComponentOption<IGroupItemDetailsHeaderProps>(),
        listProps: graftControlOption<IListProps>()
    });
